import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Variables,VariableType } from '~/core/classes/user/variables';
import { GraphService } from 'src/services/graph.service';
import { AppSettingsService } from 'src/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { ConfigService } from '@cvx/cal-angular';
import { AppConfigService } from 'src/services/appconfig.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, NgFor]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() public title: string = 'Chevron Angular Starter Kit';
  @Output() public setLayoutCssClass: EventEmitter<void> = new EventEmitter();
  @Output() public reloadPage: EventEmitter<void> = new EventEmitter();

  public appSettings: AppSettings = new AppSettings();
  public env: string = '';
  public itemsClass: string = '';
  public initials: string = '';
  public showPhoto: boolean = false;
  public userRole: string = '';
  public acceptedRoles: string[] = [];
  public userRoles: string[] = [];
  public isPowerUser: boolean = false;
  public isDropdownVisible: boolean = false;
  readadd: boolean = false;
  

  constructor(
    private router: Router,
    private graphService: GraphService,
    private configService: ConfigService,
    private appSettingsService: AppSettingsService,
    private elementRef: ElementRef,
    private appConfigService: AppConfigService
  ) {
  }

  // Lifecycle hook to initialize user info and bind event
  public async ngOnInit(): Promise<void> {
    // Config is already loaded by APP_INITIALIZER, just get the environment
    this.loadEnvironmentConfig();
    
    await this.getUserInfo();
    document.addEventListener('click', this.boundHandleClickOutside);
  }

  // Lifecycle hook to clean up event listener
  public ngOnDestroy(): void {
    document.removeEventListener('click', this.boundHandleClickOutside);
  }

  // Navigates to the given URL using Angular router
  public navigateTo(url: string): void {
    this.router.navigateByUrl(url);
  }

  // Toggles dropdown visibility for role switcher
  public toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  // Handles selection of a role option from dropdown
  public onOptionSelect(option: string | undefined | null): void {
  if (!option) {
    this.userRole = '';
  } else {
    this.userRole = option.toString().split('-')[1]?.trim() || '';
  }
  this.isDropdownVisible = false;
  this.setUserRoleInElement();
  Variables.set('userRole', this.userRole, VariableType.Local);
}


  // Detects click outside the dropdown and hides it
  public handleClickOutside = (event: Event): void => {
    if (this.isDropdownVisible && !this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownVisible = false;
    }
  };

  private boundHandleClickOutside = this.handleClickOutside.bind(this);

  // Load environment configuration and set the environment badge
  private loadEnvironmentConfig(): void {
    try {
      const environment = this.appConfigService.getConfig('environment');
      if (environment) {
        this.env = environment.toString().toUpperCase();
      } else {
        console.warn('Environment not found in config');
      }
    } catch (error) {
      console.error('Error loading environment config:', error);
    }
  }

  // Sets the selected role text into the DOM element
  private setUserRoleInElement(): void {
    const userRoleElement = document.getElementById('userRoleElement');
    if (userRoleElement) {
      userRoleElement.innerHTML = this.userRole;
    }
  }

  // Fetches user info, sets default roles, and manages photo logic
  private async getUserInfo(): Promise<void> {
    this.appSettings = await this.appSettingsService.getSettings();
    this.acceptedRoles = this.appSettings.roles || [];
    let savedUserRole = Variables.get('userRole', VariableType.Local);
    this.userRoles = this.appSettings.user?.roles || [];
    this.isPowerUser = this.userRoles.some(role => role.includes('Power User'));
    this.acceptedRoles = this.acceptedRoles.filter(role => !role.includes('Power User') && !role.includes('Admin') &&  role.includes('Supplier Spend Visibility'));    
    this.userRoles = this.userRoles.filter(role => !role.includes('Power User') && !role.includes('Admin'));
    !savedUserRole? this.onOptionSelect(this.acceptedRoles[0]): null;
    if (savedUserRole) {
      this.userRole = typeof savedUserRole === 'string' ? savedUserRole : '';
    } else if (this.userRoles.length !== 0) {
      this.userRole = this.userRoles[0]?.split('-')[1]?.trim() || '';
    } else {
      this.userRole = this.acceptedRoles[0]?.split('-')[1]?.trim() || '';
    }

    this.setUserRoleInElement();
    Variables.set("userRole", this.userRole, VariableType.Local);


    if (this.appSettings.user?.photo !== '') {
      this.showPhoto = true;
    } else {
      const photo = await this.graphService.getUserPhoto();
      this.appSettings.user.photo = photo;
      if (photo !== '') {
        this.showPhoto = true;
      }
      this.appSettingsService.saveSettings(this.appSettings);
    }
  }
}
